import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import BurnTrackerModal from "./BurnTrackerPopup";

const BurnTrackerSection = ({volumeDaily, ufoPrice}) => {
  const [modalStatus, setModalStatus] = useState(false);
  const openModal = () => setModalStatus(true);
  const closeModal = () => setModalStatus(false);
  
  return (
    <>
      <div className="statsSN subcontent" data-aos="fade-up"  data-aos-delay="700" data-aos-duration="800">
        <div className="d-flex justify-content-between align-items-center gap-3">
          <div>
            <h2 className="gradient-stroke-text">UFO Burn Tracker</h2>
            <p>Track every UFO token burn in real-time to see how supply is decreasing over time. Stay informed on deflationary activity and its potential impact on token value and scarcity.</p>
            <div className="mt-4 pt-0 mySPace"></div>
            <button onClick={openModal}  className="mybtn underline text-white p-0"><span>View Now</span></button>
          </div>
        </div>
      </div>
      <BurnTrackerModal modalIsOpen={modalStatus} closeModal={closeModal} ufoPrice={ufoPrice} volumeDaily={volumeDaily}/>
    </>
  );
};

export default BurnTrackerSection;
